<template>
  <div class="sa-dialog sa-view-det-modal" @click.self="$emit('close-pop')">
    <div class="sa-dialog-body sa-fixed-right sa-fixed-bottom">
      <button @click="$emit('close-pop')" class="sa-dialog-close sa-line-close sa-cursor">
        <i class="icon-close"></i>
      </button>
      <div class="sa-dialog-mob-cnt">
        <h5>Selected Details</h5>
        <div v-if="loader">
          <img src="../../assets/img/loader.svg" alt="loader" class="sa-loader" />
        </div>
        <div class="sa-d-flex sa-details-card" v-for="(items,index) in nurseTests" :key="index">
          <figure class="sa-avt-img">
            <img :src="items.img" alt="" class="sa-img-cover" />
          </figure>
          <div class="sa-care">
            <h6>{{ items.heading }}</h6>
            <span class="sa-gray-text sa-pt5">{{ items.title }}</span>
          </div>
        </div>
        <LabTest :selectTests="selectTests" />
        <!-- <button class="sa-btn sa-btn-primary sa-btn-block sa-mt20 sa-mb20">Continue</button> -->
      </div>
    </div>
  </div>
</template>
<script>
import { lab_url, nurse_url } from '../../../config/endpoints';
import LabTest from './LabTest.vue';
export default {
  props: ['type', 'servId'],
  components: { LabTest },
  data() {
    return {
      loader: true,
      selectTests: null,
      nurseTests: null
    };
  },
  mounted() {
    this.viewDetails()
  },
  methods: {
    viewDetails() {
      this.utid = JSON.parse(this.$localStorage.get("utid"))
      this.api = this.utid === 4 ? `${lab_url}/appointment/serviceDetails` : `${nurse_url}/appointment/serviceDetails`
      let srvObj = {
        type: this.type,
        srvc_id: this.servId
      }
      this.$store.dispatch("httpPost", { uri: this.api, body: srvObj }).then(response => {
        if (response && response.status === 1000) {
          this.loader = false
          this.selectTests = response.data.selected_tests
          this.nurseTests = response.data.nurse_selected_tests
        } else {
          this.loader = false
          this.$store.dispatch('SET_ALERTMESSAGE', { 'msg': response.message, class: 'sa-a-danger' })
        }
      })
    }
  },
};
</script>
